module.exports = new __parcel__URL__("pyrolance.3a356156.png").toString();